import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { GetUserInfo } from "../../../CommonFunction/GetUserInfo";
import Reactportal from "../Reactportal/Reactportal";
import "./CompanyAndBranchSelection.scss";
import { useLazyQuery } from "@apollo/client";
import { GetQuickLinks } from "../../../Utils/AllPagesQuriesAndMutations";

const CompanyBranchSection = ({ setToggle, show }) => {
  const [compdata, setCompData] = useState<any[]>([]);
  const [openModal, setOpenModal] = useState(show);
  const [userDetails, setUserDetails] = useState<any>({});
  const selectedBranch = JSON.parse(sessionStorage.getItem("BranchCode"))?.id;
  const dispatch = useDispatch();

  const Closeformfunction1 = () => {
    setToggle(false);
    setOpenModal(false);
    dispatch({ type: "ClearData", payload: { data: {} } });
  };

  useEffect(() => {
    let res = GetUserInfo();
    // console.log(res)
    setUserDetails(res?.userDetails[0]);
    setCompData(res?.CompanyAccess);
  }, []);

  const [getQuickLinks] = useLazyQuery(GetQuickLinks, {
    fetchPolicy: "network-only",
  });

  const handleClick = async (companyId, branchId) => {
    let compObj = {
      Name: companyId?.Company_ID?.Name,
      id: companyId?.Company_ID?._id,
      CompanyCodeName: companyId?.Company_ID?.Company_Code,
      CompanyCode: companyId?.Company_ID?.Unique_Id,
      GST_Number: companyId?.Company_ID?.GST_Number,
      Pincode: companyId?.Company_ID?.Pincode,
      State: companyId?.Company_ID?.State,
    };
    let branchObj = {
      Name: branchId.Name,
      id: branchId._id,
      BranchCode: branchId.Unique_Id,
      GST_Number: branchId.GST_Number,
    };
    sessionStorage.removeItem("SelectedFinancialYear");
    sessionStorage.setItem("CompanyCode", JSON.stringify(compObj));
    sessionStorage.setItem("BranchCode", JSON.stringify(branchObj));

    await getQuickLinks({
      variables: {
        User_ID: userDetails?._id,
        companyId: compObj.id,
      },
    })
      .then((res) => {
        let obj = JSON.parse(sessionStorage.getItem("userData") ?? "{}");
        let arr = res.data.getallQuickLinksWithUserId[0]?.Page_Rights?.map((el) => el) || [];
        obj.BookMarks[0].Page_Rights = arr;
        sessionStorage.setItem("userData", JSON.stringify(obj));
      })
      .catch((err) => {
        // console.log(err, "PPPPPPPPPPPPPPKPKKKK");
      });

    window.location.reload();
    dispatch({
      type: "ChangeCompanyAndBranch",
      payload: { ...compObj, ...branchObj },
    });
    Closeformfunction1();
  };

  return (
    <>
      {show ? (
        <div>
          <Reactportal open={show} onClose={Closeformfunction1} TypeOfPortal={"Select Branch"}>
            <div className="CompanyAndBranch" key="0P">
              {compdata?.map((el) => {
                return (
                  <div>
                    <p className="compName">{el?.Company_ID?.Name}</p>
                    <div className="BranchContainer">
                      {el?.BranchAccess_Code?.map((e, i) => {
                        return (
                          <p key={i} onClick={() => handleClick(el, e)} className={selectedBranch === e?._id ? "seleteted-branch" : ""}  >
                            {e.Name}
                          </p>
                        );
                      })}
                    </div>
                  </div>
                );
              })}
            </div>
          </Reactportal>
        </div>
      ) : (
        <div></div>
      )}
    </>
  );
};

export default CompanyBranchSection;
